import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {
    HashRouter,
    Route,
    Switch
} from 'react-router-dom';

import './assets/css/bootstrap.min.css';
import './assets/css/animate.min.css';
import './assets/sass/light-bootstrap-dashboard.css';
import './assets/css/demo.css';
import './assets/css/pe-icon-7-stroke.css';
import './assets/sass/cci.css';
import 'sweetalert2/src/sweetalert2.scss'

import App from './App';
import {Provider} from "mobx-react";
import registerServiceWorker from './registerServiceWorker';
import {OnlineCertificatePage} from "./views/OnlineCertificate/OnlineCertificate";
import {SelfRegisterPage} from "./views/EventSelfRegister/SelfRegister";
import {EventRegisterPage} from "./views/EventSelfRegister/EventRegister";
import {EventPreRegister} from "./views/EventSelfRegister/EventPreRegister";

import EventStore from "./store/EventStore";
import MemberStore from "./store/MemberStore";


const store = {
    MemberStore,
    EventStore
};

ReactDOM.render(
    (<HashRouter>
        <Provider {...store}>
            <Switch>
                <Route path="/ocert" name="OnlineCertificate" component={OnlineCertificatePage}/>
                {/*<Route path="/event" name="EventRegister" component={SelfRegisterPage}/>*/}
                <Route path="/event" name="EventRegister" component={EventRegisterPage}/>
                <Route path="/preevent" name="EventPreRegister" component={EventPreRegister}/>
                <Route path="/" name="Home" component={App}/>
            </Switch>
        </Provider>
    </HashRouter>),
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js